import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    Grid,
    Card,
    Divider,
    CardContent,
    IconButton,
    Avatar,
    Chip
} from "@mui/material";
import moment from "moment";
import { RxCross2 } from "react-icons/rx";
import StatusBadge from "components/badge/StatusBadge";
import CustomTabs from "components/CustomTabs";
import DocumentManagement from "components/DocumentManagement";

const tabs = ["Approval Information", "Documents"]

const ViewApproval = (props) => {
    const { open, handleClose, rowData, isLoading } = props;
    const [tabValue, setTabValue] = useState(0);

    const submissionData = rowData?.submissions ? [...rowData.submissions] : [];
    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        mb: 0.5,
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mb: 2,
    };

    const getAvatarColor = (text) => {
        const colors = ["#1976D2", "#388E3C", "#F57C00", "#7B1FA2", "#0288D1", "#C2185B"];
        const index = text ? text.charCodeAt(0) % colors.length : 0;
        return colors[index];
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography sx={{
                        fontWeight: 600,
                        fontSize: "27px",
                        lineHeight: "100%",
                        color: "#140F36",
                        fontFamily: "Outfit, sans-serif"
                    }}>
                        View Approval Details
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <CustomTabs tabs={tabs} handleTabChange={handleTabChange} tabValue={tabValue} />
                    </Grid>
                    {tabValue === 0 &&
                        <Grid size={12}>
                            <Card
                                elevation={0}
                                sx={{
                                    borderRadius: "3px",
                                    border: "1px solid #e5e7eb",
                                    backgroundColor: "#fff",
                                    p: 2,
                                }}
                            >

                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 1,
                                    }}
                                >
                                    <Typography sx={{
                                        fontWeight: 600,
                                        fontSize: "20px",
                                        fontFamily: "Outfit, sans-serif",
                                        color: "#0A0A0C"
                                    }}>
                                        Approval Information
                                    </Typography>
                                </Box>

                                <Divider sx={{ mb: 3 }} />

                                <CardContent sx={{ pt: 0 }}>
                                    <Grid container spacing={2}>
                                        <Grid size={{ xs: 12 }}>
                                            <Grid container spacing={1}>
                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Phase:</strong>
                                                    </Typography>
                                                    <Box sx={{ display: "flex", alignItems: 'center', gap: 1, mb: 2, p: 0 }}>
                                                        <Avatar
                                                            sx={{
                                                                width: 30,
                                                                height: 30,
                                                                bgcolor: getAvatarColor(rowData?.approvalAgreement || ""),
                                                                color: "#fff",
                                                                fontSize: "14px",
                                                                fontWeight: "bold",
                                                                p: 0,
                                                                m: 0
                                                            }}
                                                        >
                                                            {rowData?.phase?.[0] || "?"}
                                                        </Avatar>
                                                        <Typography sx={valueStyle}>
                                                            {rowData?.phase ?? "N/A"}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Permit/Approval/Agreement</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.permitApprovalAgreement ?? "N/A"}
                                                    </Typography>
                                                </Grid>

                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Permitting Entity:</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.permittingEntity ?? "N/A"}
                                                    </Typography>
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Validity :</strong>
                                                    </Typography>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                        <Typography sx={{
                                                            ...valueStyle,
                                                            color: "#388e3c",
                                                            fontWeight: 600
                                                        }}>
                                                            {rowData?.validity ?
                                                                moment(rowData.validity).format("DD MMM YYYY") :
                                                                "N/A"}
                                                        </Typography>
                                                    </Box>
                                                </Grid>


                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Details:</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.details ?? "N/A"}
                                                    </Typography>
                                                </Grid>

                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Responsibility :</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.responsibility ?? "N/A"}
                                                    </Typography>
                                                </Grid>
                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Timelines :</strong>
                                                    </Typography>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                        <Typography sx={{
                                                            ...valueStyle,
                                                            color: "#388e3c",
                                                            fontWeight: 600
                                                        }}>
                                                            {rowData?.timelines ?
                                                                moment(rowData.timelines).format("DD MMM YYYY") :
                                                                "N/A"}
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>SPOC :</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.spoc ?? "N/A"}
                                                    </Typography>
                                                </Grid>

                                                <Grid size={{ xs: 12, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Target timelines for attaining the permit :</strong>
                                                    </Typography>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
                                                        <Typography sx={{
                                                            ...valueStyle,
                                                            color: "#d32f2f",
                                                            fontWeight: 600
                                                        }}>
                                                            {rowData?.targetDate ?
                                                                moment(rowData.targetDate).format("DD MMM YYYY") :
                                                                "N/A"}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Status:</strong>
                                                    </Typography>
                                                    <Box sx={{ mb: 2 }}>
                                                        <StatusBadge status={rowData?.status} />
                                                    </Box>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                                    <Typography sx={labelStyle}>
                                                        <strong>Remarks :</strong>
                                                    </Typography>
                                                    <Typography sx={valueStyle}>
                                                        {rowData?.remarks ?? "N/A"}
                                                    </Typography>
                                                </Grid>


                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                    {tabValue === 1 &&
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={rowData?.statutoryTrackerId} entityType="Statutory" customId={rowData?.customId} isView={true} />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ViewApproval;